import service from "@/utils/request";

// 学生点评明细列表
export interface commentStudentListData {
  student_ids?: number[];
  page?: number;
  page_size?: number;
  class_id?: number;
  staff_id?: number;
  subject_id?: number;
  start_time?: number;
  end_time?: number;
  comment_start_time?: number;
  comment_end_time?: number;
  comment_time?: number;
}
export const commentStudentListApi = (params: commentLessonDetailData) => {
  return service({
    url: "/api/v1/teacher/lesson/comment/comment_student_list",
    method: "get",
    params,
  });
};

// 课堂点评列表
export interface commentListData {
  page?: number;
  page_size?: number;
  status?: number;
  class_id?: number;
  staff_id?: number;
  subject_id?: number;
  attend_class_start_time?: number;
  attend_class_end_time?: number;
  comment_start_time?: number;
  comment_end_time?: number;
  comment_time?: number;
}
export const commentListApi = (params: commentListData) => {
  return service({
    url: "/api/v1/teacher/lesson/comment/list",
    method: "get",
    params,
  });
};

// 提交点评
export interface commentSubmitData {
  lesson_comment_student_id: number;
  comment_id: number;
  student_id: number;
  lesson_star: {
    A: number;
    B: number;
    C: number;
    D: number;
    E: number;
  };
  class_situation: string;
  resource: {
    type: number;
    url: string;
  };
  comment_time: number;
  is_commit: boolean;
}
export const commentSubmitApi = (data: commentSubmitData) => {
  return service({
    url: "/api/v1/teacher/lesson/comment/submit",
    method: "post",
    data,
  });
};

// 删除学员点评
export interface delStudentCommentData {
  lesson_comment_student_id: number;
}
export const delStudentCommentApi = (data: delStudentCommentData) => {
  return service({
    url: "/api/v1/teacher/lesson/comment/del_student_comment",
    method: "post",
    data,
  });
};

// 课次点评详细
export interface commentLessonDetailData {
  lesson_comment_id: number;
}
export const commentLessonDetailApi = (params: commentLessonDetailData) => {
  return service({
    url: "/api/v1/teacher/lesson/comment/lesson_detail",
    method: "get",
    params,
  });
};

// 老师端 - 点评详细
export interface lessonCommentDetailData {
  comment_student_id: number;
}
export const lessonCommentDetailApi = (params: lessonCommentDetailData) => {
  return service({
    url: "/api/v1/teacher/lesson/comment/detail",
    method: "get",
    params,
  });
};
